module.exports = __webpack_public_path__ + "static/media/bbva.f8a74989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/features/bbva.png
// module id = 1573
// module chunks = 0